import _ from 'underscore';
import Backbone from 'backbone';


module.exports = Backbone.Collection.extend({
  initialize(models, options) {
    this.options = _.extend({
      urlBase: '/parentpay/accounts/bank/settlement/'
    }, options);
  },

  url() {
    return this.options.urlBase;
  }
});



// WEBPACK FOOTER //
// ./transactions/collections/account.js